// en, de, fr, pt
const new_language = {
  en: {
    settings: 'Settings',
    language_management: 'Language management',
    language: 'Language',
    expressions: 'Expressions',
    role_management: 'Role management',
    roles: 'Roles',
    users: 'Users',
    page_management: 'Page management',
    pages: 'Pages',
    features: 'Features',
    year_opening_management: 'Year opening management',
    school_year: 'school year',
    school_years: 'School years',
    levels: 'Levels',
    types_of_partitions: 'Types of partitions',
    partitions: 'Partitions',
    add: 'Add',
    name: 'Name',
    activate_deactivate: 'Activate / Deactivate',
    active: 'Active ?',
    action: 'Action',
    update: 'Update',
    YES: 'YES',
    NO: 'NO',
    No_data_Available: 'No data Available',
    The_name_is_required: 'The name is required.',
    Submit: 'Submit',
    Cancel: 'Cancel',
    new: 'New',
    update_a: 'Update a',
    The_level_is_added_successfully: 'The level is added successfully.',
    The_level_is_changed_successfully: 'The level is changed successfully.',
    level: 'Level',
    The_form_is_invalid: 'The form is invalid',
    of_sur: 'of',
    Search: 'Search',
    Delete: 'Delete',
    The_level_is_actived_successfully: 'The level is actived successfully',
    The_level_is_deactived_successfully: 'The level is deactived successfully',
    partition_type: 'partition type',
    The_partition_type_is_added_successfully: 'The partition type is added successfully.',
    The_partition_type_is_changed_successfully: 'The partition type is changed successfully.',
    The_number_of_partition_is_required: 'The number of partition is required.',
    number_of_partition: 'Number of partitions',
    The_level_is_deleted_successfully: 'The level is deleted successfully.',
    Level_removal_failed: 'Level removal failed.',
    The_partition_type_is_deleted_successfully: 'The partition type is deleted successfully.',
    Partition_type_removal_failed: 'Partition type removal failed.',
    Years: 'Years',
    year: 'year',
    Year_removal_failed: 'Year removal failed.',
    The_year_is_deleted_successfully: 'The year is deleted successfully.',
    The_year_is_added_successfully: 'The year is added successfully.',
    The_year_is_changed_successfully: 'The year is changed successfully.',
    Please_close_the_current_school_year_before_opening_another: 'Please close the current school year before opening another.',
    State_of_the_school_year: 'State of the school year',
    Start_date: 'Start date',
    End_date: 'End date',
    Closing_date: 'Closing date',
    In_progress: 'In progress',
    Closed: 'Closed',
    The_server_is_not_responding: 'The server is not responding.',
    Confirm_deletion: 'Confirm deletion?',
    Confirmation: 'Confirmation',
    Confirm: 'Confirm',
    The_school_year_is_deleted_successfully: 'The school year is deleted successfully.',
    School_year_removal_failed: 'School year removal failed',
    Chat_socket_closed_unexpectedly: 'Chat socket closed unexpectedly.',
    Start_year: 'Start year',
    End_year: 'End year',
    The_start_year_is_required: 'The start year is required.',
    The_end_year_is_required: 'The end year is required.',
    The_start_date_is_required: 'The start date is required.',
    First: 'Premier',
    Second: 'Deuxième',
    Third: 'Troisième',
    Fourth: 'Quatrième',
    Fifth: 'Cinquième',
    First_1st: '1er',
    Second_2nd: '2e',
    Third_3rd: '3e',
    Fourth_4th: '4e',
    Fifth_5th: '5e',
    The_school_year_is_added_successfully: 'The school year is added successfully.',
    The_partition_type_is_required: 'The partition type is required.',
    class_management: 'Class management',
    class: 'Class',
    room: 'Room',
    The_level_is_required: 'The level is required.',
    The_code_is_required: 'The code is required.',
    code: 'Code',
    The_class_is_added_successfully: 'The class is added successfully.',
    The_class_is_changed_successfully: 'The class is changed successfully.',
    The_class_is_deleted_successfully: 'The class is deleted successfully.',
    Class_removal_failed: 'Class removal failed.',
    Filter: 'Filter',
    Filterlist: 'Filter list',
    number_of_room: 'Number of rooms',
    The_number_of_room_is_required: 'The number of room is required.',
    room_capacity: 'Room capacity',
    The_class_is_actived_successfully: 'The class is actived successfully.',
    The_class_is_deactived_successfully: 'The class is deactived successfully.',
    serie: 'Serie',
    The_serie_is_added_successfully: 'The serie is added successfully.',
    The_serie_is_changed_successfully: 'The serie is changed successfully.',
    The_serie_is_deleted_successfully: 'The serie is deleted successfully.',
    Serie_removal_failed: 'Serie removal failed.',
    The_room_is_actived_successfully: 'The room is actived successfully.',
    The_room_is_deactived_successfully: 'The room is deactived successfully.',
    The_room_capacity_is_required: 'The room capacity is required.',
    The_room_is_added_successfully: 'The room is added successfully.',
    The_room_is_changed_successfully: 'The room is changed successfully.',
    sex: 'Sex',
    The_sex_is_added_successfully: 'The sex is added successfully.',
    The_sex_is_changed_successfully: 'The sex is changed successfully.',
    The_sex_is_deleted_successfully: 'The sex is deleted successfully.',
    Sex_removal_failed: 'Sex removal failed.',
    accounting_management: 'Accounting management',
    type_of_fees: 'Type of fees',
    fees: 'Fees',
    The_type_of_fees_is_added_successfully: 'The type of fees is added successfully.',
    The_type_of_fees_is_changed_successfully: 'The type of fees is changed successfully.',
    The_number_of_slice_is_required: 'The number of slice is required.',
    number_of_slice: 'Number of slice',
    The_type_of_fees_is_deleted_successfully: 'The type of fees is deleted successfully.',
    Type_of_fees_removal_failed: 'Type of fees removal failed.',
    In_which_classes_will_you_use_this_type_of_fee: 'In which classes will you use this type of fee ?',
    Amount: 'Amount',
    The_amount_is_required: 'The amount is required.',
    The_end_date_is_required: 'The end date is required.',
    There_is_no_open_school_year: 'There is no open school year.',
    The_fees_is_added_successfully: 'The fees is added successfully.',
    Student_management: 'Student management',
    Student: 'Student',
    Parent: 'Parent',
    Personal_information: 'Personal information',
    Parent_or_guardian: 'Parent or guardian',
    School_information: 'School information',
    Student_status: 'Student status',
    Classroom: 'Classroom',
    Entry_date: 'Entry date',
    Last_name: 'Last name',
    First_names: 'First names',
    Phone_number_1: 'Phone number 1',
    Phone_number_2: 'Phone number 2',
    Address: 'Address',
    Contact: 'Contact',
    Date_of_Birth: 'Date of Birth',
    Remove_a_parent: 'Remove a parent',
    Registration_number: 'Registration number',
    The_Student_status_is_added_successfully: 'The Student status is added successfully.',
    The_Student_status_is_changed_successfully: 'The Student status is changed successfully.',
    The_Student_status_is_deleted_successfully: 'The Student status is deleted successfully.',
    Student_status_removal_failed: 'Student status removal failed.',
    Abbreviation: 'Abbreviation',
    The_abbreviation_is_required: 'The abbreviation is required.',
    The_student_is_added_successfully: 'The student is added successfully.',
    The_student_is_changed_successfully: 'The student is changed successfully.',
    The_Date_of_Birth_is_required: 'The Date of Birth is required.',
    The_sex_is_required: 'The sex is required.',
    The_Last_name_is_required: 'The Last name is required.',
    The_First_names_is_required: 'The First names is required.',
    The_Address_is_required: 'The Address is required.',
    The_Phone_number_1_is_required: 'The Phone number 1 is required.',
    The_Entry_date_is_required: 'The Entry date is required.',
    The_Student_status_is_required: 'The Student status is required.',
    The_Classroom_is_required: 'The Classroom is required.',
    full_name: 'Full name',
    The_parent_is_added_successfully: 'The parent is added successfully.',
    The_parent_is_changed_successfully: 'The parent is changed successfully.',
    Employee: 'Employee',
    Post: 'Post',
    Employee_management: 'Employee management',
    Standart_salary: 'Standart salary',
    Title_Post: 'Title Post',
    The_Title_Post_is_required: 'The Title Post is required.',
    The_Standart_salary_is_required: 'The Standart salary is required.',
    The_post_is_added_successfully: 'The post is added successfully.',
    The_post_is_changed_successfully: 'The post is changed successfully.',
    place_of_birth: 'Place of birth',
    person_to_contact: 'Person to contact',
    post_box: 'Post Box',
    city: 'City',
    district: 'District',
    Cnss_Registration_number: 'Cnss Registration number',
    Marital_status: 'Marital status',
    filiation: 'Filiation',
    number_of_people: 'Number of people',
    declared: 'Declared',
    withoutTcs: 'WithoutTcs',
    Gross_wages: 'Gross wages',
    The_place_of_birth_is_required: 'The place of birth is required.',
    The_person_to_contact_is_required: 'The person to contact is required.',
    The_post_box_is_required: 'The post box is required.',
    The_city_is_required: 'The city is required.',
    The_district_is_required: 'The district is required.',
    The_Cnss_Registration_number_is_required: 'The Cnss Registration number is required.',
    The_post_is_required: 'The post is required.',
    The_Marital_status_is_required: 'The Marital status is required.',
    The_filiation_is_required: 'The filiation is required.',
    The_number_of_people_in_charge_is_required: 'The number of people in charge is required.',
    The_Gross_wages_is_required: 'The Gross wages is required.',
    The_Marital_status_is_added_successfully: 'The Marital status is added successfully.',
    The_Marital_status_is_changed_successfully: 'The Marital status is changed successfully.',
    The_employee_is_added_successfully: 'The employee is added successfully.',
    The_employee_is_changed_successfully: 'The employee is changed successfully.',
    report_cards_management: 'Report cards management ',
    occupied_position: 'Occupied position',
    matter_type: 'Matter type',
    matter: 'Matter',
    matter_by_class: 'Matter by class',
    teachers: 'Teachers',
    exam: 'Exam',
    exam_type: 'Exam type',
    report_card: 'Report card',
    The_exam_type_is_added_successfully: 'The exam type is added successfully.',
    The_exam_type_is_changed_successfully: 'The exam type is changed successfully.',
    The_exam_type_is_deleted_successfully: 'The exam type is deleted successfully.',
    Exam_type_removal_failed: 'Exam type removal failed.',
    The_matter_type_is_added_successfully: 'The matter type is added successfully.',
    The_matter_type_is_changed_successfully: 'The matter type is changed successfully.',
    The_matter_type_is_deleted_successfully: 'The matter type is deleted successfully.',
    Matter_type_removal_failed: 'Matter type removal failed.',
    The_matter_is_added_successfully: 'The matter is added successfully.',
    The_matter_is_changed_successfully: 'The matter is changed successfully.',
    The_matter_is_deleted_successfully: 'The matter is deleted successfully.',
    Matter_removal_failed: 'Matter removal failed.',
    coefficient: 'Coefficient',
    The_class_is_required: 'The class is required.',
    The_matter_is_required: 'The matter is required.',
    The_matter_type_is_required: 'The matter type is required.',
    The_coefficient_is_required: 'The coefficient is required.',
    The_matter_by_class_is_added_successfully: 'The matter by class is added successfully.',
    The_matter_by_class_is_changed_successfully: 'The matter by class is changed successfully.',
    Actions: 'Actions',
    multiple_add: 'Multiple add',
    The_matters_by_class_are_added_successfully: 'The matters by class are added successfully.',
    professor: 'Professor',
    This_position_is_for_teachers: 'This position is for teachers.',
    This_post_is_not_for_teachers: 'This post is not for teachers.',
    matter_by_teachers: 'Matter by teachers',
    The_matter_by_teachers_is_added_successfully: 'The matter by teachers is added successfully.',
    The_matter_by_teachers_is_changed_successfully: 'The matter by teachers is changed successfully.',
    The_matter_by_teachers_is_deleted_successfully: 'The matter by teachers is deleted successfully.',
    Matter_by_teachers_removal_failed: 'Matter by teachers removal failed.',
    The_room_is_required: 'The room is required.',
    The_Employee_is_required: 'The Employee is required.',
    The_matter_by_class_is_required: 'The matter by class is required.',
    The_matter_by_class_is_deleted_successfully: 'The matter by class is deleted successfully.',
    This_registration_already_exists_Please_choose_another_registration: 'This registration already exists. Please choose another registration.',
    Failure: 'Failure!',
    Success: 'Success!',
    student_by_partition: 'Student by partition',
    Dispense_from_a_matter: 'Dispense from a matter',
    partition: 'Partition',
    The_student_by_partition_is_deleted_successfully: 'The student by partition is deleted successfully.',
    student_by_partition_removal_failed: 'Student by partition removal failed',
    The_student_by_partition_is_added_successfully: 'The student by partition is added successfully.',
    The_student_by_partition_is_changed_successfully: 'The student by partition is changed successfully.',
    The_Student_is_required: 'The Student is required.',
    The_partition_is_required: 'The partition is required.',
    The_student_by_partition_are_added_successfully: 'The student by partition are added successfully.',
    The_student_by_partition_is_actived_successfully: 'The student by partition is actived successfully.',
    The_student_by_partition_is_deactived_successfully: 'The student by partition is deactived successfully.',
    The_Dispense_from_a_matter_is_added_successfully: 'The Dispense from a matter is added successfully.',
    The_Dispense_from_a_matter_is_changed_successfully: 'The Dispense from a matter is changed successfully.',
    The_matter_by_teachers_is_required: 'The matter by teachers is required.',
    The_Dispense_from_a_matter_are_added_successfully: 'The Dispense from a matter are added successfully.',
    The_Dispense_from_a_matter_is_actived_successfully: 'The Dispense from a matter is actived successfully.',
    The_Dispense_from_a_matter_is_deactived_successfully: 'The Dispense from a matter is deactived successfully.',
    The_Dispense_from_a_matter_is_deleted_successfully: 'The Dispense from a matter is deleted successfully.',
    Dispense_from_a_matter_removal_failed: 'Dispense from a matter removal failed.',
    This_filed_is_required: 'This filed is required.',
    This_field_must_be_numeric_and_may_contain_decimal_points: 'This field must be numeric and may contain decimal points.',
    This_field_must_be_20_or_less: 'This field must be 20 or less.',
    This_field_must_be_0_or_more: 'This field must be 0 or more.',
    notes: 'Notes',
    The_type_examen_is_required: 'The type examen is required',
    Abandonment: 'Abandonment',
    Confirm_abandonment: 'Confirm abandonment',
    The_abandonment_is_saved_successfully: 'The abandonment is saved successfully',
    Abandonment_saving_failed: 'Abandonment_saving_failed',
    Abandoned: 'Abandoned',
    Waiting: 'Waiting',
    valuation_date: 'Valuation date',
    start_time: 'Start time',
    end_time: 'End time',
    The_valuation_date_is_required: 'The valuation date is required.',
    The_start_time_is_required: 'The start time is required.',
    The_end_time_is_required: 'The end time is required.',
    appreciation: 'Appreciation',
    start_number: 'Start number',
    end_number: 'End number',
    The_start_number_is_required: 'The start number is required',
    The_end_number_is_required: 'The end number is required',
    The_appreciation_is_added_successfully: 'The appreciation is added successfully',
    The_appreciation_is_changed_successfully: 'The appreciation is changed successfully',
    The_appreciation_is_required: 'The appreciation is required',
    Cancel_abandonment: 'Cancel abandonment',
    The_abandonment_is_canceled_successfully: 'The abandonment is canceled successfully',
    Abandonment_canceling_failed: 'Abandonment canceling failed',
    Update_image: 'Update image',
    Remove_image: 'Remove image',
    Profile: 'Profile',
    Full_name: 'Full name',
    average: 'Average',
    rank: 'Rank',
    all_report_card: 'All report card',
    rank_by_partition: 'Rank by partition',
    annual_rank: 'Annual rank',
    induvidual_report_card: 'Induvidual report card',
    upload_report_card: 'Upload report card',
    upload: 'Upload',
    occupied_places: 'Occupied places',
    is_it_full: 'Is it full?',
    Old_report_card: 'Old report card',
    Download: 'Download',
    download_old_report_card: 'Download old report card',
    download_aproved_report_card: 'Download aproved report card',
    Assign_a_room_to_students: 'Assign a room to students',
    Remove_students_from_a_room: 'Remove students from a room',
    This_room_does_not_contain_students: 'This room does not contain students',
    Select_all: 'Select all',
    Changes_have_been_made_successfully: 'Changes have been made successfully',
    Assign_Remove_student: ' Assign / Remove student',
    Logout: 'Logout',
    The_Exam_is_added_successfully: 'The Exam is added successfully',
    The_Exam_is_changed_successfully: 'The Exam is changed successfully',
    Definition: 'Definition',
    The_picture_is_changed_successfully: 'The picture is changed successfully',
    Upload_image: 'Upload_image',
    Picture: 'Picture',
    Upload_picture: 'Upload picture',
    students: 'Students',
    Girls: 'Girls',
    Boys: 'Boys',
    Number_of_students: 'Number of students',
    In_good_standing: 'In good standing',
    Abandonment_pending: 'Abandonment pending',
    Total: 'Total',
    Attendance: 'Attendance',
    Date: 'Date',
    Present: 'Present',
    Absent: 'Absent',
    The_Attendance_is_added_successfully: 'The Attendance is added successfully',
    The_date_is_required: 'The date is required',
    The_Attendance_is_deleted_successfully: 'The Attendance is deleted successfully',
    Attendance_removal_failed: 'Attendance removal failed',
    Date_of_attendance: 'Date of attendance',
    Upload_evidence: 'Upload evidence',
    Download_evidence: 'Download evidence',
    Old_evidence: 'Old evidence',
    The_evidence_is_changed_successfully: 'The evidence is changed successfully',
    Evidence_changing_failed: 'Evidence changing failed',
    list_of_students: 'List of students',
    note_card: 'Note card',
    attendance_record: 'Attendance record',
    school: 'School',
    update_school_information: 'Update school information',
    head_of_school: 'Head of school',
    school_name: 'School name',
    school_bp: 'School bp',
    school_address: 'School address',
    school_email: 'School email',
    school_tel1: 'School phone number 1',
    school_tel2: 'School phone number 2',
    school_tel3: 'School phone number 3',
    school_logo: 'School logo',
    The_head_of_school_is_required: 'The head of school is required',
    The_school_name_is_required: 'The school name is required',
    The_school_bp_is_required: 'The school bp is required',
    The_school_address_is_required: 'The school address is required',
    The_school_email_is_required: 'The school email is required',
    Upload_logo: 'Upload logo',
    School_information_has_been_changed_successfully: 'School information has been changed successfully',
    Excel_file_header: 'Excel file header',
    Create_a_batch_of_students: 'Create a batch of students',
    Full_professor_per_room: 'Full professor per room',
    The_Full_professor_per_room_is_added_successfully: 'The Full professor per room is added successfully',
    The_Full_professor_per_room_is_changed_successfully: 'The Full professor per room is changed successfully',
    The_Full_professor_per_room_is_deleted_successfully: 'The Full professor per room is deleted successfully',
    This_room_already_has_a_full_professor: 'This room already has a full professor',
    short_label: 'Short label',
    long_label: 'Long label',
    The_partition_is_actived_successfully: 'The partition is actived successfully',
    The_partition_is_deactived_successfully: 'The partition is deactived successfully',
    Please_activate_a_partition_before_continuing: 'Please activate a partition before continuing',
    school_fees: 'School fees',
    Add_school_fees_payment: 'Add school fees payment',
    Remaining_mount: 'Remaining amount',
    Total_amount: 'Total amount',
    Amount_to_pay: 'Amount to pay',
    State_of_payments: 'State of payments',
    Slice: 'Slice',
    Not_solded: 'Not solded',
    Solded: 'Solded',
    Payed: 'Payed',
    This_field_must_be_less_or_equal_to_the_remaining_amount: 'This field must be less or equal to the remaining amount',
    Old: 'Old',
    the_abbreviation_in_the_bulletin_is_required: 'the abbreviation in the bulletin is required',
    the_total_in_the_bulletin_is_required: 'the total in the bulletin is required',
    the_title_in_the_bulletin_is_required: 'the title in the bulletin is required',
    abbreviationBulletin: 'Report card abbreviation',
    totalBulletin: 'Report card total',
    titleBulletin: 'Report card title',
    The_Report_Card_is_changed_successfully: 'The Report Card is changed successfully',
    The_report_card_is_deleted_successfully: 'The report card is deleted successfully',
    Report_card_removal_failed: 'Report card removal failed',
    The_payment_is_added_successfully: 'The payment is added successfully',
    Receipts: 'Receipts',
    Date_of_payment: 'Date of payement',
    etat_financier: 'État Financier'
  }
}

export default new_language
